import React from 'react'
import ReactDOM from 'react-dom'
import 'styles/index.scss'
import * as serviceWorker from 'utils/serviceWorkerHelper'
import * as Sentry from '@sentry/browser'
import { Integrations } from '@sentry/tracing'
import App from './App'
import { getCookie, isEmpty } from 'utils/browserHelper'
import { getCurrencyByLocale } from 'utils/currencyHelper'
import TagManager from 'react-gtm-module'
import {
    ApolloClient,
    InMemoryCache,
    ApolloProvider,
    useQuery,
    gql,
    HttpLink,
    ApolloLink,
    concat
} from '@apollo/client'

// const tagManagerArgs = {
//     gtmId: 'GTM-T9S432'
// }
// TagManager.initialize(tagManagerArgs)
if (process.env.CT_ENV == 'production') {
    const {
        SENTRY_DSN = 'https://dc91cd2741ea4541a6e1056e4d5a13a3@o1075047.ingest.sentry.io/6078739',
        CT_ENV = 'NOT_DETECTED',
        LOCALE_LANG = 'NOT_DETECTED',
        TEMPLATE = 'NOT_DETECTED',
        BITBUCKET_BUILD_NUMBER = 'NOT_DETECTED',
        BITBUCKET_BRANCH = 'NOT_DETECTED',
        BITBUCKET_COMMIT = 'NOT_DETECTED'
    } = process.env
    Sentry.init({
        // dsn: 'https://7b6f0b16529c48dbbf44a3e886450748@sentry.io/1810977',
        dsn: SENTRY_DSN,
        environment: CT_ENV,
        integrations: [new Integrations.BrowserTracing()],
        tracesSampleRate: 1.0,
        // release: `build:build_no`, // can provide build number
        release: `build:${BITBUCKET_BUILD_NUMBER}`,
        whitelistUrls: [/.*cleartrip.*/, /.*cltpstatic.*/]
    })
    Sentry.configureScope(function(scope) {
        scope.setTag('locale_lang', LOCALE_LANG)
        scope.setTag('template', TEMPLATE)
        scope.setTag('domain', window && window.location.hostname)
        // scope.setTag('BITBUCKET_BUILD_NUMBER', BITBUCKET_BUILD_NUMBER)
        scope.setTag('bitbucket_branch', BITBUCKET_BRANCH)
        scope.setTag('bitbucket_commit', BITBUCKET_COMMIT)
    })
    const [, , , , userId] = decodeURIComponent(getCookie('userid') || '').split('|')
    if (userId) {
        Sentry.configureScope(function(scope) {
            scope.setUser({ id: userId })
        })
    }
}

function getGqlUrl() {
    const domain = window.location.hostname
    switch (domain) {
        case 'localhost':
            return 'https://qa2new.cleartrip.com/graphql'
        // case 'www.cleartrip.com':
        //     return 'https://gql.cleartrip.com/graphql'
        // case 'qa2.cleartrip.com':
        //     return 'https://qa2.cleartrip.com/graphql'
        // case 'qa2new.cleartrip.com':
        //     return 'https://qa2new.cleartrip.com/graphql'
        default:
            return '/graphql'
    }
}
const httpLink = new HttpLink({ uri: getGqlUrl() })

const authMiddleware = new ApolloLink((operation, forward) => {
    // add the authorization to the headers
    const ctAb = isEmpty(getCookie('ct-ab')) ? {} : JSON.parse(decodeURIComponent(getCookie('ct-ab')))
    const { currency , locale } = getCurrencyByLocale();
    
    operation.setContext(({ headers = {} }) => ({
        headers: {
            ...headers,
            'X-CT-SOURCETYPE': 'DESKTOP',
            'app-agent': 'DESKTOP',
            'x-locale': locale || 'IN',
            'x-currency':  currency ||'INR',
            'x-cookie': document && document.cookie,
        }
    }))

    return forward(operation)
})

const client = new ApolloClient({
    cache: new InMemoryCache().restore(window.__APOLLO_STATE__),
    link: concat(authMiddleware, httpLink)
})
// const client = new ApolloClient({
//     uri: getGqlUrl(),
//     //uri: 'http://localhost:9080/graphql',
//     cache: new InMemoryCache().restore(window.__APOLLO_STATE__),
//     request: operation => {
//         operation.setContext({
//             headers: {
//                 'X-CT-SOURCETYPE': 'DESKTOP',
//                 'app-agent': 'DESKTOP',
//                 'x-locale': 'IN',
//                 'x-currency': 'INR',
//                 'x-cookie': document && document.cookie
//             }
//         })
//     }
// })

ReactDOM.render(<App client={client} />, document.getElementById('root'))

// Service Worker helper added to utils
serviceWorker.unregister()
